export default __webpack_public_path__ + "static/media/microblog.7741bc83.png";